import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "../styles/landingPage.css";
import { TokenProvider, Text, Icon, Button } from "@jds/core";
import { IcArrowNext } from "@jds/core-icons";
import { useNavigate } from "react-router-dom";
import config from "../utils/config";
import heroImage from "url:../assets/assetsM/Jio Consent Marketing website assets/Hero_image.svg";
import meityRecognisedRibbon from "url:../assets/meity-recognised-ribbon.svg";
import winnersOfMeityImg from "url:../assets/WinnerOfMeity.avif";
import relianceJewelsLogo from "url:../assets/trusted-reliance-jewels-logo.svg";
import relianceMedLabLogo from "url:../assets/assetsM/RelianceMedLabLogo.svg";
import consentIllustration from "url:../assets/assetsM/illustration-01-consent-management.svg";
import consentModalIllustration from "url:../assets/assetsM/illustration-01-consent-management-modal.svg";
import cookieIllustration from "url:../assets/assetsM/illustration-02-cookie-consent.svg";
import breachIllustration from "url:../assets/assetsM/illustration-04-breach-notifications.svg";
import grievanceIllustration from "url:../assets/assetsM/illustration-03-grievance-redressal.svg";
import ropaIllustration from "url:../assets/assetsM/illustration-05-ropa.svg";
import illustrationStep1ConnectConfigure from "url:../assets/assetsM/illustration-step1-connect-configure.svg";
import illustrationStep2ReportCertify from "url:../assets/assetsM/illustration-step2-report-certify.svg";
import illustrationStep3MonitorManage from "url:../assets/assetsM/illustration-step3-monitor-manage.svg";
import forDevelopersIllustration from "url:../assets/assetsM/Jio Consent Marketing website assets/FOR DEVELOPERS.svg";

// ─── SVG helpers ────────────────────────────────────────────────────────────

function JioLogoSVG({ width = 36, height = 36 }) {
  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <g clipPath="url(#jio-logo-clip)">
        <mask id="jio-logo-mask" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="36" height="36">
          <path d="M0 0H36V36H0V0Z" fill="white" />
        </mask>
        <g mask="url(#jio-logo-mask)">
          <path d="M18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18C0 8.05888 8.05888 0 18 0Z" fill="#0F3CC9" />
          <path d="M12.7173 10.857H12.1173C10.9787 10.857 10.3567 11.4991 10.3567 12.7834V18.9774C10.3567 20.5721 9.81802 21.1317 8.55432 21.1317C7.56032 21.1317 6.75265 20.6964 6.11032 19.9094C6.04799 19.8267 4.74365 20.4477 4.74365 21.981C4.74365 23.638 6.29631 24.6534 9.17695 24.6534C12.677 24.6534 14.5217 22.8924 14.5217 19.0397V12.7834C14.5196 11.5007 13.8984 10.857 12.7173 10.857ZM26.6673 13.8814C23.2697 13.8814 21.012 16.0357 21.012 19.2481C21.012 22.5421 23.1864 24.6554 26.6046 24.6554C30.0013 24.6554 32.238 22.5421 32.238 19.2694C32.24 16.0357 30.023 13.8814 26.6673 13.8814ZM26.6256 21.6077C25.2993 21.6077 24.3883 20.6343 24.3883 19.2464C24.3883 17.8797 25.3217 16.9057 26.6256 16.9057C27.9296 16.9057 28.8627 17.8797 28.8627 19.2673C28.863 20.6134 27.9104 21.6077 26.626 21.6077H26.6256ZM18.1413 13.9847H17.7263C16.712 13.9847 15.9457 14.4607 15.9457 15.9113V22.54C15.9457 24.0111 16.6917 24.467 17.7684 24.467H18.183C19.198 24.467 19.9227 23.9694 19.9227 22.54V15.9113C19.9227 14.42 19.219 13.9847 18.1413 13.9847ZM17.9136 9.17969C16.629 9.17969 15.8213 9.905 15.8213 11.0444C15.8213 12.2037 16.6503 12.9287 17.9756 12.9287C19.26 12.9287 20.0679 12.2037 20.0679 11.0444C20.0679 9.88502 19.2393 9.17969 17.9136 9.17969Z" fill="white" />
        </g>
      </g>
      <defs>
        <clipPath id="jio-logo-clip"><rect width="36" height="36" fill="white" /></clipPath>
      </defs>
    </svg>
  );
}

function ArrowRightSVG({ width = 16, height = 16, stroke = "white" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden style={{ display: "block", flexShrink: 0 }}>
      <path d="M3.3335 8H12.6668" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 3.33301L12.6667 7.99967L8 12.6663" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** FAQ screen 6 — Figma: 20×20, stroke 1.67px, arm length ~11.67px (IcAdd is fill-based 24 viewBox, not this spec). */
function FaqTogglePlus({ className = "" }) {
  return (
    <svg
      className={className ? `lp-faq-icon-svg ${className}` : "lp-faq-icon-svg"}
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M10 4.165V15.835"
        stroke="currentColor"
        strokeWidth={1.67}
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M4.165 10H15.835"
        stroke="currentColor"
        strokeWidth={1.67}
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}

function FaqToggleMinus({ className = "" }) {
  return (
    <svg
      className={className ? `lp-faq-icon-svg ${className}` : "lp-faq-icon-svg"}
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M4.165 10H15.835"
        stroke="currentColor"
        strokeWidth={1.67}
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}

/** Last screen — DPDPA trust tile (Figma asset, unique filter id per instance). */
function FinalTrustDpdpaShieldIcon() {
  const filterId = `lp-ft-dpdpa-dd-${React.useId().replace(/:/g, "")}`;
  return (
    <svg width={48} height={48} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="3" y="2" width="48" height="48" rx="12" fill="#0F3CC9" />
      <g filter={`url(#${filterId})`}>
        <rect x="3" y="2" width="48" height="48" rx="12" fill="white" fillOpacity="0.01" shapeRendering="crispEdges" />
      </g>
      <path
        d="M33.6663 26.8331C33.6663 30.9997 30.7497 33.0831 27.283 34.2914C27.1015 34.3529 26.9043 34.35 26.7247 34.2831C23.2497 33.0831 20.333 30.9997 20.333 26.8331V20.9997C20.333 20.5395 20.7061 20.1664 21.1663 20.1664C22.833 20.1664 24.9163 19.1664 26.3663 17.8997C26.7311 17.5881 27.2683 17.5881 27.633 17.8997C29.0913 19.1747 31.1663 20.1664 32.833 20.1664C33.2932 20.1664 33.6663 20.5395 33.6663 20.9997V26.8331"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter id={filterId} x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="dpdpa_fs1_morph" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha2" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha2" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

/** Last screen — MeitY trust tile (Figma asset). */
function FinalTrustMeitYBuildingIcon() {
  const filterId = `lp-ft-meity-dd-${React.useId().replace(/:/g, "")}`;
  return (
    <svg width={48} height={48} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="3" y="2" width="48" height="48" rx="12" fill="#B45309" />
      <g filter={`url(#${filterId})`}>
        <rect x="3" y="2" width="48" height="48" rx="12" fill="white" fillOpacity="0.01" shapeRendering="crispEdges" />
      </g>
      <path d="M25.333 31.0003V25.167" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M26.2663 17.8316C26.7297 17.6065 27.2711 17.6083 27.7329 17.8366L34.2879 21.0424C34.6846 21.2366 34.5463 21.8332 34.1046 21.8332H19.8946C19.4529 21.8332 19.3154 21.2366 19.7113 21.0424L26.2663 17.8316"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M28.667 31.0003V25.167" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M32 31.0003V25.167" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.5 34.333H34.5" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 31.0003V25.167" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <filter id={filterId} x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="meity_fs1_morph" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha2" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha2" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

/** Last screen — SOC 2 trust tile (Figma asset). */
function FinalTrustSoc2VerifiedIcon() {
  const uid = React.useId().replace(/:/g, "");
  const filterId = `lp-ft-soc2-dd-${uid}`;
  const clipId = `lp-ft-soc2-clip-${uid}`;
  return (
    <svg width={48} height={48} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="3" y="2" width="48" height="48" rx="12" fill="#7C3AED" />
      <g filter={`url(#${filterId})`}>
        <rect x="3" y="2" width="48" height="48" rx="12" fill="white" fillOpacity="0.01" shapeRendering="crispEdges" />
      </g>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M20.208 23.1836C19.9608 22.07 20.3002 20.9074 21.1076 20.1017C21.915 19.296 23.0783 18.959 24.1913 19.2086C24.8039 18.2506 25.8626 17.6709 26.9997 17.6709C28.1368 17.6709 29.1954 18.2506 29.808 19.2086C30.9228 18.9579 32.0883 19.2958 32.8962 20.1037C33.7042 20.9117 34.042 22.0771 33.7913 23.1919C34.7494 23.8045 35.329 24.8631 35.329 26.0002C35.329 27.1374 34.7494 28.196 33.7913 28.8086C34.0409 29.9216 33.704 31.0849 32.8982 31.8924C32.0925 32.6998 30.9299 33.0391 29.8163 32.7919C29.2045 33.7537 28.1437 34.3361 27.0038 34.3361C25.864 34.3361 24.8031 33.7537 24.1913 32.7919C23.0783 33.0414 21.915 32.7045 21.1076 31.8988C20.3002 31.0931 19.9608 29.9305 20.208 28.8169C19.2425 28.2059 18.6572 27.1429 18.6572 26.0002C18.6572 24.8576 19.2425 23.7946 20.208 23.1836V23.1836"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M24.5 25.9997L26.1667 27.6663L29.5 24.333" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <filter id={filterId} x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="soc2_fs1_morph" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha2" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha2" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" transform="translate(17 16)" />
        </clipPath>
      </defs>
    </svg>
  );
}

/** Last screen — ISO 27001 trust tile (Figma asset). */
function FinalTrustIsoPersonStarIcon() {
  const filterId = `lp-ft-iso-dd-${React.useId().replace(/:/g, "")}`;
  return (
    <svg width={48} height={48} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="3" y="2" width="48" height="48" rx="12" fill="#0EA5E9" />
      <g filter={`url(#${filterId})`}>
        <rect x="3" y="2" width="48" height="48" rx="12" fill="white" fillOpacity="0.01" shapeRendering="crispEdges" />
      </g>
      <path
        d="M29.8973 26.7412L31.1598 33.8462C31.1888 34.0175 31.1084 34.1888 30.9581 34.276C30.8078 34.3632 30.6192 34.348 30.4848 34.2379L27.5015 31.9987C27.2057 31.7777 26.7998 31.7777 26.504 31.9987L23.5156 34.237C23.3814 34.347 23.193 34.3622 23.0429 34.2753C22.8927 34.1883 22.8121 34.0174 22.8406 33.8462L24.1023 26.7412"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 22.667C22 25.4266 24.2404 27.667 27 27.667C29.7596 27.667 32 25.4266 32 22.667C32 19.9074 29.7596 17.667 27 17.667C24.2404 17.667 22 19.9074 22 22.667V22.667"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter id={filterId} x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="iso_fs1_morph" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha2" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha2" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

/** Figma trusted bar — Facebook icon (28×28) */
function TrustedFacebookIcon({ className }) {
  return (
    <svg className={className} width={28} height={28} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <g clipPath="url(#trusted_fb_icon_clip)">
        <path
          d="M28 14.0859C28 6.35444 21.7315 0.0859375 14 0.0859375C6.2685 0.0859375 0 6.35444 0 14.0859C0 21.0743 5.11933 26.8656 11.8125 27.9156V18.1331H8.25767V14.0848H11.8125V11.0024C11.8125 7.49427 13.9032 5.55527 17.101 5.55527C18.6317 5.55527 20.2347 5.82944 20.2347 5.82944V9.2746H18.4683C16.7288 9.2746 16.1863 10.3538 16.1863 11.4609V14.0859H20.069L19.4483 18.1343H16.1863V27.9168C22.8807 26.8656 28 21.0731 28 14.0859Z"
          fill="#1877F2"
        />
      </g>
      <defs>
        <clipPath id="trusted_fb_icon_clip">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

/** Figma trusted bar — Reliance Jewels (175×40) */
function TrustedRelianceJewelsLogo({ className }) {
  return (
    <img
      className={className}
      src={relianceJewelsLogo}
      alt="Reliance Jewels"
      width={175}
      height={40}
      loading="lazy"
      decoding="async"
    />
  );
}

/** Figma trusted bar — Reliance MedLab (assetsM) */
function TrustedRelianceMedicalLogo({ className }) {
  return (
    <img
      className={className}
      src={relianceMedLabLogo}
      alt="Reliance MedLab"
      width={104}
      height={48}
      loading="lazy"
      decoding="async"
    />
  );
}

/** Figma trusted bar — Facebook wordmark (89×28) */
function TrustedFacebookWordmark({ className }) {
  return (
    <svg className={className} width={89} height={28} viewBox="0 0 89 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path
        d="M7.32251 10.082V12.3137H0.195312V10.082H7.32251ZM2.12225 21V9.24399C2.12225 8.46833 2.27651 7.8232 2.58504 7.30861C2.89357 6.79402 3.31535 6.40821 3.85038 6.15118C4.38541 5.89414 4.98868 5.76562 5.66017 5.76562C6.12254 5.76562 6.54407 5.80244 6.92474 5.87607C7.30541 5.94971 7.58546 6.01406 7.76489 6.06914L7.23442 8.27974C7.11515 8.24367 6.97172 8.20962 6.80414 8.17759C6.63656 8.14556 6.45544 8.12955 6.26079 8.12955C5.81535 8.12955 5.50058 8.23537 5.31647 8.44702C5.13236 8.65867 5.0403 8.95609 5.0403 9.33928V21H2.12225ZM11.3674 21.2117C10.6737 21.2117 10.0524 21.0894 9.5033 20.8448C8.95421 20.6002 8.52244 20.2361 8.20799 19.7523C7.89354 19.2686 7.73631 18.6669 7.73631 17.9473C7.73631 17.3363 7.84771 16.8268 8.07049 16.4186C8.29327 16.0104 8.59819 15.6816 8.98523 15.4324C9.37227 15.1832 9.81205 14.9936 10.3046 14.8636C10.7971 14.7336 11.3131 14.643 11.8525 14.592C12.4825 14.5284 12.9911 14.4686 13.3784 14.4125C13.7657 14.3564 14.0498 14.2686 14.2308 14.1491C14.4118 14.0296 14.5023 13.8523 14.5023 13.617V13.5689C14.5023 13.2574 14.4361 12.9938 14.3038 12.7782C14.1714 12.5627 13.9782 12.3975 13.724 12.2828C13.4698 12.168 13.1574 12.1106 12.7867 12.1106C12.4136 12.1106 12.0871 12.1674 11.8075 12.2809C11.5278 12.3944 11.2987 12.546 11.1204 12.7357C10.942 12.9253 10.8135 13.1383 10.735 13.3746L8.04881 12.9287C8.23383 12.2928 8.54463 11.7534 8.98122 11.3105C9.41781 10.8676 9.96035 10.5293 10.6089 10.2957C11.2574 10.0621 11.9864 9.94531 12.7959 9.94531C13.382 9.94531 13.9517 10.0147 14.5051 10.1536C15.0585 10.2925 15.5552 10.5097 15.9952 10.8053C16.4351 11.1009 16.7844 11.4831 17.043 11.952C17.3016 12.4208 17.4309 12.9868 17.4309 13.6498V21H14.6529V19.484H14.5568C14.3804 19.8223 14.1458 20.1212 13.853 20.3809C13.5602 20.6405 13.208 20.8439 12.7965 20.991C12.3849 21.1381 11.9085 21.2117 11.3674 21.2117ZM12.1922 19.158C12.6534 19.158 13.0585 19.0662 13.4075 18.8826C13.7565 18.699 14.0298 18.4512 14.2272 18.1392C14.4247 17.8273 14.5234 17.4798 14.5234 17.0969V15.9155C14.4342 15.9755 14.3026 16.0318 14.1285 16.0843C13.9544 16.1368 13.7602 16.1839 13.5459 16.2254C13.3316 16.2669 13.12 16.303 12.9111 16.3335C12.7023 16.364 12.5167 16.3908 12.3545 16.4139C11.9946 16.4625 11.6782 16.5449 11.4053 16.6613C11.1324 16.7778 10.9204 16.9334 10.7694 17.1283C10.6184 17.3232 10.5428 17.5675 10.5428 17.8611C10.5428 18.1438 10.6141 18.3813 10.7567 18.5737C10.8993 18.7661 11.0941 18.9116 11.3412 19.0101C11.5884 19.1087 11.872 19.158 12.1922 19.158ZM24.3084 21.2133C23.2133 21.2133 22.2667 20.978 21.4685 20.5075C20.6704 20.037 20.055 19.3795 19.6225 18.5349C19.1901 17.6903 18.9738 16.7081 18.9738 15.5883C18.9738 14.4595 19.1901 13.4721 19.6225 12.626C20.055 11.7799 20.6704 11.1216 21.4685 10.6511C22.2667 10.1806 23.2133 9.94531 24.3084 9.94531C24.9588 9.94531 25.5571 10.0295 26.1032 10.1979C26.6493 10.3662 27.1336 10.6071 27.5561 10.9205C27.9786 11.2339 28.3263 11.6147 28.5993 12.0629C28.8722 12.5111 29.0607 13.015 29.1647 13.5747L26.4416 14.0848C26.381 13.8013 26.2896 13.5468 26.1673 13.3212C26.0449 13.0957 25.8955 12.9028 25.7188 12.7425C25.5422 12.5823 25.3384 12.4603 25.1075 12.3764C24.8766 12.2926 24.6208 12.2506 24.3401 12.2506C23.8183 12.2506 23.3811 12.391 23.0284 12.6716C22.6756 12.9523 22.4091 13.3421 22.2287 13.841C22.0483 14.34 21.9581 14.9189 21.9581 15.5777C21.9581 16.2271 22.0483 16.8022 22.2287 17.3032C22.4091 17.8042 22.6756 18.1969 23.0284 18.4813C23.3811 18.7657 23.8183 18.908 24.3401 18.908C24.6238 18.908 24.8826 18.8644 25.1165 18.7773C25.3504 18.6902 25.5581 18.5641 25.7394 18.3992C25.9208 18.2342 26.0727 18.0333 26.195 17.7964C26.3173 17.5596 26.407 17.2947 26.464 17.0017L29.1827 17.5066C29.0816 18.0828 28.8939 18.5982 28.6195 19.0529C28.3451 19.5076 27.9967 19.8964 27.5745 20.2193C27.1522 20.5422 26.6656 20.7886 26.1148 20.9585C25.5639 21.1284 24.9618 21.2133 24.3084 21.2133ZM35.6328 21.2133C34.5184 21.2133 33.5575 20.9851 32.7504 20.5286C31.9432 20.0722 31.3233 19.424 30.8905 18.5842C30.4578 17.7443 30.2414 16.7487 30.2414 15.5973C30.2414 14.474 30.4564 13.4885 30.8864 12.6409C31.3164 11.7933 31.9246 11.1322 32.711 10.6574C33.4974 10.1827 34.4223 9.94531 35.4858 9.94531C36.1988 9.94531 36.865 10.0589 37.4844 10.2861C38.1038 10.5134 38.6474 10.856 39.1152 11.3141C39.5829 11.7721 39.9483 12.3477 40.2112 13.0408C40.4741 13.7339 40.6055 14.5481 40.6055 15.4834V16.3055H31.4433V14.4625H39.1783L37.8095 14.9566C37.8095 14.3881 37.7227 13.8941 37.5491 13.4746C37.3755 13.0551 37.1183 12.7297 36.7775 12.4983C36.4368 12.2669 36.0132 12.1512 35.5068 12.1512C35.0005 12.1512 34.5709 12.2684 34.2182 12.5028C33.8655 12.7371 33.5971 13.0551 33.4129 13.4567C33.2288 13.8582 33.1368 14.3148 33.1368 14.8264V16.1238C33.1368 16.7553 33.2425 17.2859 33.4539 17.7154C33.6653 18.145 33.9626 18.4677 34.3458 18.6836C34.7291 18.8994 35.1737 19.0074 35.6795 19.0074C36.0213 19.0074 36.3319 18.9587 36.6114 18.8614C36.8909 18.7641 37.1312 18.6199 37.3324 18.4291C37.5336 18.2382 37.6867 18.0029 37.7918 17.7232L40.4403 18.2131C40.264 18.8162 39.9582 19.3428 39.5229 19.7929C39.0876 20.2429 38.5422 20.5922 37.8867 20.8406C37.2313 21.0891 36.48 21.2133 35.6328 21.2133ZM48.2268 21.1816C47.6352 21.1816 47.1339 21.0813 46.723 20.8806C46.3121 20.6799 45.9787 20.4316 45.7227 20.1359C45.4667 19.8402 45.2699 19.5458 45.1321 19.2525H44.9895V21H42.109V6.44922H45.0376V11.9197H45.1321C45.2663 11.6295 45.4582 11.3319 45.7077 11.0269C45.9572 10.7218 46.2876 10.4653 46.699 10.2573C47.1104 10.0493 47.6252 9.94531 48.2434 9.94531C49.0529 9.94531 49.792 10.1538 50.4608 10.5709C51.1295 10.9879 51.6652 11.6128 52.0679 12.4453C52.4706 13.2779 52.6719 14.316 52.6719 15.5598C52.6719 16.7714 52.4766 17.7951 52.086 18.6309C51.6954 19.4667 51.1648 20.1008 50.4943 20.5331C49.8238 20.9655 49.068 21.1816 48.2268 21.1816ZM47.325 18.8341C47.8363 18.8341 48.2652 18.6941 48.6117 18.4142C48.9582 18.1343 49.2206 17.7467 49.399 17.2515C49.5774 16.7564 49.6666 16.1894 49.6666 15.5508C49.6666 14.9116 49.5781 14.3474 49.4012 13.8582C49.2243 13.369 48.9627 12.9858 48.6162 12.7086C48.2697 12.4314 47.8393 12.2928 47.325 12.2928C46.8232 12.2928 46.3972 12.4269 46.0469 12.6952C45.6967 12.9634 45.4306 13.3406 45.2487 13.8268C45.0668 14.313 44.9758 14.8876 44.9758 15.5508C44.9758 16.2069 45.0675 16.7809 45.2509 17.2728C45.4343 17.7647 45.7019 18.1479 46.0537 18.4224C46.4054 18.6969 46.8292 18.8341 47.325 18.8341ZM59.1027 21.2133C58.0077 21.2133 57.0602 20.978 56.2602 20.5075C55.4603 20.037 54.8441 19.3795 54.4116 18.5349C53.9791 17.6903 53.7629 16.7081 53.7629 15.5883C53.7629 14.4595 53.9791 13.4721 54.4116 12.626C54.8441 11.7799 55.4603 11.1216 56.2602 10.6511C57.0602 10.1806 58.0077 9.94531 59.1027 9.94531C60.2008 9.94531 61.1488 10.1806 61.9467 10.6511C62.7446 11.1216 63.3598 11.7799 63.7923 12.626C64.2248 13.4721 64.4411 14.4595 64.4411 15.5883C64.4411 16.7081 64.2248 17.6903 63.7923 18.5349C63.3598 19.3795 62.7446 20.037 61.9467 20.5075C61.1488 20.978 60.2008 21.2133 59.1027 21.2133ZM59.1027 18.908C59.624 18.908 60.0598 18.7631 60.4102 18.4734C60.7607 18.1837 61.0235 17.7875 61.1986 17.2847C61.3737 16.782 61.4613 16.213 61.4613 15.5777C61.4613 14.9359 61.3737 14.3648 61.1986 13.8644C61.0235 13.3639 60.7607 12.9699 60.4102 12.6822C60.0598 12.3945 59.624 12.2506 59.1027 12.2506C58.581 12.2506 58.1455 12.3945 57.7963 12.6822C57.4471 12.9699 57.185 13.3632 57.0098 13.8621C56.8347 14.3611 56.7471 14.9329 56.7471 15.5777C56.7471 16.213 56.8347 16.782 57.0098 17.2847C57.185 17.7875 57.4471 18.1837 57.7963 18.4734C58.1455 18.7631 58.581 18.908 59.1027 18.908ZM70.8684 21.2133C69.7733 21.2133 68.8258 20.978 68.0259 20.5075C67.2259 20.037 66.6097 19.3795 66.1772 18.5349C65.7447 17.6903 65.5285 16.7081 65.5285 15.5883C65.5285 14.4595 65.7447 13.4721 66.1772 12.626C66.6097 11.7799 67.2259 11.1216 68.0259 10.6511C68.8258 10.1806 69.7733 9.94531 70.8684 9.94531C71.9664 9.94531 72.9144 10.1806 73.7123 10.6511C74.5103 11.1216 75.1255 11.7799 75.5579 12.626C75.9904 13.4721 76.2067 14.4595 76.2067 15.5883C76.2067 16.7081 75.9904 17.6903 75.5579 18.5349C75.1255 19.3795 74.5103 20.037 73.7123 20.5075C72.9144 20.978 71.9664 21.2133 70.8684 21.2133ZM70.8684 18.908C71.3896 18.908 71.8254 18.7631 72.1759 18.4734C72.5263 18.1837 72.7891 17.7875 72.9642 17.2847C73.1393 16.782 73.2269 16.213 73.2269 15.5777C73.2269 14.9359 73.1393 14.3648 72.9642 13.8644C72.7891 13.3639 72.5263 12.9699 72.1759 12.6822C71.8254 12.3945 71.3896 12.2506 70.8684 12.2506C70.3466 12.2506 69.9112 12.3945 69.562 12.6822C69.2128 12.9699 68.9506 13.3632 68.7755 13.8621C68.6003 14.3611 68.5128 14.9329 68.5128 15.5777C68.5128 16.213 68.6003 16.782 68.7755 17.2847C68.9506 17.7875 69.2128 18.1837 69.562 18.4734C69.9112 18.7631 70.3466 18.908 70.8684 18.908ZM80.4053 17.802V14.2794H80.8489L84.4199 10.082H87.8053L83.0888 15.5576H82.3977L80.4053 17.802ZM77.7476 21V6.44922H80.6762V21H77.7476ZM84.5623 21L81.2897 16.212L83.2464 14.1332L88.0153 21H84.5623Z"
        fill="#1877F2"
      />
    </svg>
  );
}

/** Figma MeitY stat tiles — 44×48, gradient squircle + blue glyph */
function MeityStatDocumentLogo({ className }) {
  return (
    <svg className={className} width={44} height={48} viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect y="4" width="44" height="44" rx="12" fill="url(#meity_stat_doc_grad)" />
      <path d="M23.9698 27.3618C23.7717 27.5598 23.6267 27.8046 23.5482 28.0735L22.8507 30.4651C22.8081 30.6112 22.8485 30.7688 22.956 30.8764C23.0636 30.984 23.2213 31.0244 23.3673 30.9818L25.759 30.2843C26.0279 30.2058 26.2726 30.0608 26.4707 29.8626L29.8148 26.5218C30.5061 25.8305 30.5061 24.7097 29.8148 24.0185C29.1236 23.3272 28.0028 23.3272 27.3115 24.0185L23.9698 27.3618" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24.0728 22.5477C23.8212 22.3973 23.6671 22.1258 23.667 21.8327V17.666" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M28.6663 32.3702V32.666C28.6663 33.5865 27.9201 34.3327 26.9997 34.3327H16.9997C16.0792 34.3327 15.333 33.5865 15.333 32.666V19.3327C15.333 18.4122 16.0792 17.666 16.9997 17.666H23.6663C24.1991 17.6652 24.7103 17.8769 25.0863 18.2544L27.183 20.351" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.667 31H19.5003" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="meity_stat_doc_grad" x1="0" y1="4" x2="44" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0F3CC9" stopOpacity="0.1" />
          <stop offset="1" stopColor="#8E51FF" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function MeityStatRefreshLogo({ className }) {
  return (
    <svg className={className} width={44} height={48} viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect y="4" width="44" height="44" rx="12" fill="url(#meity_stat_refresh_grad)" />
      <path d="M14.5 26C14.5 30.1394 17.8606 33.5 22 33.5C26.1394 33.5 29.5 30.1394 29.5 26C29.5 21.8606 26.1394 18.5 22 18.5C19.9033 18.5079 17.8908 19.326 16.3833 20.7833L14.5 22.6667" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 18.5V22.6667H18.6667" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="meity_stat_refresh_grad" x1="0" y1="4" x2="44" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0F3CC9" stopOpacity="0.1" />
          <stop offset="1" stopColor="#8E51FF" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function MeityStatChecklistLogo({ className }) {
  return (
    <svg className={className} width={44} height={48} viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect y="4" width="44" height="44" rx="12" fill="url(#meity_stat_list_grad)" />
      <path d="M22.833 20.166H29.4997" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.833 26H29.4997" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.833 31.834H29.4997" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 30.1667L16.1667 31.8333L19.5 28.5" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 21.8327L16.1667 23.4993L19.5 20.166" stroke="#0F3CC9" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="meity_stat_list_grad" x1="0" y1="4" x2="44" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0F3CC9" stopOpacity="0.1" />
          <stop offset="1" stopColor="#8E51FF" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
}

// ─── Data ───────────────────────────────────────────────────────────────────

/* Desktop keeps Figma <br> lines; mobile joins with spaces so words are not glued. */
function ResponsiveCopy({ lines }) {
  return (
    <>
      <span className="lp-copy-desktop">
        {lines.map((line, index) => (
          <React.Fragment key={`${index}-${line}`}>
            {index > 0 ? <br /> : null}
            {line}
          </React.Fragment>
        ))}
      </span>
      <span className="lp-copy-mobile">{lines.join(" ")}</span>
    </>
  );
}

const scrollToSection = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

const INITIAL_DEMO_FORM = {
  fullName: "",
  workEmail: "",
  company: "",
  phone: "",
  jobTitle: "",
  message: "",
  consent: false,
};

const MEITY_STATS = [
  { value: "50+ Million", label: "Consents created successfully", Icon: MeityStatDocumentLogo, figmaLogo: true },
  { value: "3+ Lakh", label: "Consents revoked transparently by users", Icon: MeityStatRefreshLogo, figmaLogo: true },
  { value: "1.2 Billion", label: "Consents validated & tracked securely", Icon: MeityStatChecklistLogo, figmaLogo: true },
];

/* Figma platform grid: row1 = Consent + Cookie (3+3 cols); row2 = Grievance + Breach + ROPA (2+2+2 cols). Order must match CSS nth-child placement. */
const PLATFORM_FEATURES = [
  {
    id: "consent",
    title: "Consent Management",
    description:
      "Capture, store, and manage user consent across all touchpoints with tamper-proof audit trails and purpose-linked records built for DPDP Act.",
    illustration: consentIllustration,
  },
  {
    id: "cookie",
    title: "Cookie Consent",
    description:
      "Deploy regulation-aware cookie banners with auto-scan, script blocking, and geo-aware display rules. Fully customizable to match\u00A0your\u00A0brand.",
    illustration: cookieIllustration,
  },
  {
    id: "grievance",
    /* Line 1 / line 2 per layout spec (Figma) */
    title: "Grievance Redressal and\nData Principal Rights",
    description:
      "Give users a structured channel to raise concerns and exercise their rights. Every request can be tracked from submission to resolution, within statutory timelines.",
    illustration: grievanceIllustration,
  },
  {
    id: "breach",
    title: "Breach Notifications",
    description:
      "Log incidents, classify risk, and manage data breach notifications from a single workflow. Every breach is recorded with full metadata and routed to your DPO (Data Protection Officer) for review before any notification goes out.",
    illustration: breachIllustration,
    hideReadMore: true,
  },
  {
    title: "Record of Processing Activities (ROPA)",
    description:
      "Maintain a comprehensive Record of Processing Activities. Auto-generate and keep your ROPA up to date with real-time data flow mapping. Always audit-ready, never out of date.",
    illustration: ropaIllustration,
    hideReadMore: true,
  },
];

/* Figma: Consent Management “Read more” modal (first platform card only) */
const CONSENT_READ_MORE_MODAL = {
  eyebrow: "CONSENT MANAGEMENT",
  title: "Collect, manage, and prove user consent at scale",
  lead:
    "Every consent interaction is captured, stored and linked to a purpose with tamper-proof audit trails that hold up under scrutiny. Manage the full lifecycle from collection to withdrawal, across every channel your users touch.",
  bullets: [
    "Granular consent capture linked to specific purposes, durations, and processing activities",
    "Automated lifecycle management — renewals, withdrawals, and expiry handled without manual intervention",
    "Multi-language support and templates aligned to DPDPA notice requirements",
    "Real-time consent status dashboard with compliance scoring",
    "Integrates with any platforms like CRMs, CDPs, etc.",
  ],
};

/* Figma: Cookie Consent “Read more” modal (second platform card) — art: assetsM/illustration-02-cookie-consent.svg */
const COOKIE_READ_MORE_MODAL = {
  eyebrow: "COOKIE CONSENT",
  title: "Cookie compliance that enforces itself",
  lead:
    "Deploy a fully configurable consent banner across your websites and apps. Every preference is captured immutably, enforced consistently, and logged for audit without engineering overhead.",
  bullets: [
    "Configurable banner with category-based consent: Essential, Functional, Analytics, Marketing",
    "Preference recall across sessions and devices",
    "Multi-language support and branding customisation",
    "Script blocking so third-party trackers don't fire until consent is given",
    "Immutable audit log of every preference change",
  ],
};

/* Grievance (third platform card) “Read more” — art: assetsM/illustration-03-grievance-redressal.svg; same modal shell as Consent/Cookie */
const GRIEVANCE_READ_MORE_MODAL = {
  eyebrow: "GRIEVANCE & PRINCIPAL RIGHTS",
  title: "Every rights request handled on time and on record",
  leadParagraphs: [
    "Data Principals submit requests - access, correction, erasure, withdrawal - through a structured embedded journey. Each request becomes a digitally signed, immutable record.",
    "Your team works through requests based on defined workflows with SLA tracking, escalation paths, automated notifications and complete audit tracking.",
  ],
  bullets: [
    { head: "Full rights coverage:", tail: " access, correction, erasure, objection, withdrawal" },
    { head: "Digitally signed, tamper-proof grievance records", tail: " from submission" },
    { head: "SLA-based workflows", tail: " with automatic escalation and deadline tracking" },
    { head: "Automated notifications", tail: " keeping Data Principals informed at every stage" },
    { head: "Complete audit trail", tail: " on every action taken against every request" },
  ],
};

/* How it works — “Read more” modals (fourth screen); same shell as platform modals; art from assetsM */
const HOW_READ_MORE_STEP1 = {
  eyebrow: "STEP 1",
  title: "Connect & Configure",
  lead:
    "Integrate across your Data Fiduciary portals, processor systems, and user-facing applications using standard APIs and pre-built UI components. Authentication runs on OAuth. Once connected, Secure Code and Consent Handle identifiers map every session to the right tenant, business unit, and purpose across web, mobile, WebView, and POS. Every user action is recorded with a digital signature and an immutable transaction log. Signed callbacks keep your downstream systems in sync in real time.",
  bullets: [
    "OAuth-based authentication and secure API integration",
    "Secure Code and Consent Handle generation for accurate session mapping",
    "SDK and embedded UI components for web, mobile, WebView, and POS",
    "Digitally signed, immutable transaction recording",
    "Real-time signed callbacks for system synchronisation",
  ],
};

const HOW_READ_MORE_STEP2 = {
  eyebrow: "STEP 2",
  title: "Monitor & Manage",
  lead:
    "Every system event — consent, grievance, configuration change, login, notification — is written to an append-only, cryptographically verifiable audit ledger. Hash-chaining and encrypted payload references ensure records cannot be altered after the fact. Compliance teams, internal auditors, and regulators can search, verify, and export activity across the full event history.",
  bullets: [
    "Immutable, append-only audit ledger with hash-chaining",
    "Cryptographically verifiable records across all event types",
    "Advanced search and reporting for compliance and audit teams",
  ],
};

const HOW_READ_MORE_STEP3 = {
  eyebrow: "STEP 3",
  title: "Report & Certify",
  lead:
    "Dashboards and reports covering key compliance and operational metrics such as consent trends, withdrawal patterns, SLA performance, purpose-level analytics, parental consent activity, and grievance resolution timelines. These insights support governance, compliance tracking, and privacy strategy by enabling data-driven decision-making, improving visibility into system performance, and ensuring regulatory readiness. Key capabilities:",
  bullets: [
    "Real-time dashboards and comprehensive scheduled reports",
    "Consent and withdrawal trend analysis",
    "SLA performance monitoring",
    "Purpose-level analytics",
    "Parental consent tracking",
    "Grievance resolution insights",
    "Designed for governance, compliance, and decision-making",
  ],
};

function getReadMoreModalBundle(modal) {
  if (!modal) return null;
  const bundles = {
    consent: { copy: CONSENT_READ_MORE_MODAL, illustration: consentModalIllustration, titleId: "lp-consent-modal-title" },
    cookie: { copy: COOKIE_READ_MORE_MODAL, illustration: cookieIllustration, titleId: "lp-cookie-modal-title" },
    grievance: { copy: GRIEVANCE_READ_MORE_MODAL, illustration: grievanceIllustration, titleId: "lp-grievance-modal-title" },
    howStep1: { copy: HOW_READ_MORE_STEP1, illustration: illustrationStep1ConnectConfigure, titleId: "lp-how-modal-title-step1" },
    howStep2: { copy: HOW_READ_MORE_STEP2, illustration: illustrationStep2ReportCertify, titleId: "lp-how-modal-title-step2" },
    howStep3: { copy: HOW_READ_MORE_STEP3, illustration: illustrationStep3MonitorManage, titleId: "lp-how-modal-title-step3" },
  };
  return bundles[modal] ?? null;
}

const HOW_STEPS = [
  {
    badge: "Step 1",
    title: "Connect & Configure",
    readMoreKey: "howStep1",
    description:
      "One integration covers web, mobile, WebView, and POS. Sessions are mapped to the right tenant, purpose, and user.",
    illustration: illustrationStep1ConnectConfigure,
  },
  {
    badge: "Step 2",
    title: "Monitor & Manage",
    readMoreKey: "howStep2",
    description:
      "Every system event is written to a tamper-evident, cryptographically verifiable audit ledger.",
    illustration: illustrationStep2ReportCertify,
  },
  {
    badge: "Step 3",
    title: "Report & Certify",
    readMoreKey: "howStep3",
    description:
      "Dashboards and scheduled reports built for compliance teams, auditors, and regulators.",
    illustration: illustrationStep3MonitorManage,
  },
];

const FAQ_LIST = [
  {
    question: "What is a Consent Management System (CMS)?",
    answer:
      "A Consent Management System is a platform that helps organizations collect, store, manage, and track user consent for personal data processing. It ensures that businesses remain compliant with data privacy regulations like the DPDP Act, 2023.",
  },
  {
    question: "Why is consent management important under the DPDP Act 2023?",
    answer:
      "The DPDP Act, 2023 mandates that organizations obtain explicit, informed consent before collecting or processing personal data. A CMS ensures you capture valid consent, maintain audit trails, and respond to user requests within regulatory timelines.",
  },
  {
    question: "Can a Data Fiduciary update a consent once it has been given?",
    answer:
      "A Data Fiduciary can request updated consent if the purpose of data processing changes. The CMS facilitates this by notifying the Data Principal and capturing fresh consent with a clear audit trail of the change.",
  },
  {
    question: "What happens if a Data Principal withdraws consent?",
    answer:
      "When a Data Principal withdraws consent, the CMS immediately updates the consent status and triggers downstream workflows to stop data processing. All withdrawal actions are logged with timestamps for compliance records.",
  },
  {
    question: "How are grievances handled in the CMS?",
    answer:
      "The CMS provides a dedicated grievance portal where Data Principals can raise privacy concerns. Each grievance is tracked from submission to resolution with SLA monitoring and automated escalation workflows.",
  },
  {
    question: "Does the CMS support multi language consent collection?",
    answer:
      "Yes. The CMS supports multi language consent forms, banners, and preference centers, allowing organizations to communicate with users in their preferred language across all touchpoints.",
  },
  {
    question: "How does CMS handle cookie consent?",
    answer:
      "The CMS automatically scans your website for cookies and trackers, categorizes them, and deploys customizable consent banners. Non-essential cookies are blocked until the user provides explicit consent.",
  },
];

const FINAL_TRUST_BADGES = [
  { label: "DPDPA Compliant", IconComponent: FinalTrustDpdpaShieldIcon },
  { label: "MeitY Approved", IconComponent: FinalTrustMeitYBuildingIcon },
  { label: "SOC 2 Audited", IconComponent: FinalTrustSoc2VerifiedIcon },
  { label: "ISO 27001 Certified", IconComponent: FinalTrustIsoPersonStarIcon },
];

// ─── Sub-components ─────────────────────────────────────────────────────────

function PlatformFeatureCard({ id, title, description, renderIcon, illustration, showReadMore, hideReadMore, onReadMoreClick }) {
  const cardClass = ["lp-platform-card", id && `lp-platform-card--${id}`, illustration && "lp-platform-card--illustration"]
    .filter(Boolean)
    .join(" ");

  const showLink = (illustration && !hideReadMore) || showReadMore;

  return (
    <article className={cardClass}>
      {illustration ? (
        <div className="lp-platform-card-visual" aria-hidden>
          <img className="lp-platform-card-visual-img" src={illustration} alt="" width={578} height={180} decoding="async" />
        </div>
      ) : (
        <div className="lp-platform-icon">
          <Icon color="primary" ic={renderIcon()} kind="background" size="medium" />
        </div>
      )}
      <Text appearance="heading-xs" color="primary_grey_100" className="lp-platform-card-title">
        {title}
      </Text>
      <Text appearance="body-s" color="primary_grey_80" className="lp-platform-card-body">
        {description}
      </Text>
      {showLink ? (
        <a
          className="lp-platform-read-more"
          href={onReadMoreClick ? "#" : "#lp-section-features"}
          onClick={(e) => {
            e.preventDefault();
            if (onReadMoreClick) onReadMoreClick();
            else scrollToSection("lp-section-features");
          }}
        >
          Read more
          <ArrowRightSVG width={20} height={20} stroke="#0A2885" />
        </a>
      ) : null}
    </article>
  );
}

// ─── Main component ──────────────────────────────────────────────────────────

const LandingPage = () => {
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const sectionRefs = useRef([]);
  const [faqOpen, setFaqOpen] = useState(-1);
  const [readMoreModal, setReadMoreModal] = useState(null); /* "consent" | "cookie" | "grievance" | "howStep1" | "howStep2" | "howStep3" | null */
  const [demoModal, setDemoModal] = useState(null); /* null | "form" | "success" */
  const [demoForm, setDemoForm] = useState(INITIAL_DEMO_FORM);
  const [loginMenuOpen, setLoginMenuOpen] = useState(false);
  const loginMenuRef = useRef(null);
  const [mobileNavOpen, setMobileNavOpen] = useState(false); /* ≤640px: nav links live behind the ☰ toggle */
  const mobileNavRef = useRef(null);

  const closeDemoModal = () => {
    setDemoModal(null);
    setDemoForm(INITIAL_DEMO_FORM);
  };

  const handleBookDemo = () => {
    setDemoForm(INITIAL_DEMO_FORM);
    setDemoModal("form");
  };

  const handleDemoFormSubmit = (e) => {
    e.preventDefault();
    const { fullName, workEmail, company, consent } = demoForm;
    if (!String(fullName).trim() || !String(workEmail).trim() || !String(company).trim() || !consent) return;
    setDemoModal("success");
  };

  const goToLogin = (url, envName) => {
    if (!url) {
      console.warn(`${envName} is not configured`);
      return;
    }
    setLoginMenuOpen(false);
    window.location.href = url;
  };

  const handleLogin1 = () => goToLogin(config.loginUrl, "REACT_APP_LOGIN_URL");
  const handleLogin2 = () => goToLogin(config.loginUrl2, "REACT_APP_LOGIN_URL_2");
  const loginHint = (url) => {
    if (!url) return "Not configured";
    try {
      return new URL(url).host || url;
    } catch {
      return url;
    }
  };
  const handleDevDocs = () => {
    const docsUrl = (config.docsUrl || "").trim();
    if (docsUrl) {
      window.location.assign(docsUrl);
      return;
    }
    console.warn("REACT_APP_DOCS_URL is not configured");
    navigate("/contact");
  };
  const arrowIcon = (px) => <IcArrowNext width={px} height={px} style={{ display: "block" }} aria-hidden />;

  /* Single source for the primary nav so the desktop row and the ≤640px menu never drift apart. */
  const navItems = [
    { label: "Features", id: "lp-section-features" },
    { label: "How It Works", id: "lp-section-how" },
    { label: "For Developers", onNavigate: handleDevDocs },
    { label: "FAQs", id: "lp-section-faq" },
  ];

  const goToNavItem = (item) => {
    if (item.onNavigate) item.onNavigate();
    else scrollToSection(item.id);
  };

  useEffect(() => {
    if (!loginMenuOpen) return undefined;
    const onPointerDown = (e) => {
      if (loginMenuRef.current && !loginMenuRef.current.contains(e.target)) {
        setLoginMenuOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setLoginMenuOpen(false);
    };
    document.addEventListener("mousedown", onPointerDown);
    window.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      window.removeEventListener("keydown", onKey);
    };
  }, [loginMenuOpen]);

  /* Mirrors the Log In dropdown: close on outside tap, Escape, or when the
     viewport grows past the mobile breakpoint (so it can't stay stuck open). */
  useEffect(() => {
    if (!mobileNavOpen) return undefined;
    const onPointerDown = (e) => {
      if (mobileNavRef.current && !mobileNavRef.current.contains(e.target)) {
        setMobileNavOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setMobileNavOpen(false);
    };
    const onResize = () => {
      if (window.innerWidth > 640) setMobileNavOpen(false);
    };
    document.addEventListener("mousedown", onPointerDown);
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, [mobileNavOpen]);

  useEffect(() => {
    if (!readMoreModal) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setReadMoreModal(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [readMoreModal]);

  useEffect(() => {
    if (!demoModal) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") {
        setDemoModal(null);
        setDemoForm(INITIAL_DEMO_FORM);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [demoModal]);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const prevBody = document.body.style.overflow;
    const prevHtml = document.documentElement.style.overflow;
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    const sections = sectionRefs.current.filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      },
      { threshold: [0.05, 0.35, 0.65], root }
    );
    sections.forEach((s) => observer.observe(s));

    return () => {
      observer.disconnect();
      document.body.style.overflow = prevBody;
      document.documentElement.style.overflow = prevHtml;
    };
  }, []);

  const readMoreBundle = getReadMoreModalBundle(readMoreModal);

  return (
    <TokenProvider value={{ theme: "JioBase", mode: "light" }}>
      <div className="lp-root" ref={rootRef} role="main">

        {/* ── Section 1: Hero ── */}
        <div className="lp-scroll-section" ref={(el) => { sectionRefs.current[0] = el; }} aria-label="Introduction">
          <section className="lp-hero" aria-label="Introduction">
            <div className="lp-hero-blobs" aria-hidden />

            <header className="lp-navbar" role="banner">
              <div className="lp-navbar-row">
                <div className="lp-brand">
                  <span className="lp-brand-logo" aria-label="Jio"><JioLogoSVG width={36} height={36} /></span>
                  <span className="lp-brand-title">Consent Management</span>
                </div>
                <nav className="lp-hero-nav" aria-label="Primary navigation">
                  {navItems.map((item) => (
                    <button
                      key={item.id || item.label}
                      type="button"
                      className="lp-hero-nav-link"
                      onClick={() => goToNavItem(item)}
                    >
                      <span className="lp-nav-label">{item.label}</span>
                    </button>
                  ))}
                </nav>
                <div className="lp-navbar-actions">
                  <div className="lp-login-menu" ref={loginMenuRef}>
                    <button
                      type="button"
                      className={`lp-nav-btn lp-nav-btn--login${loginMenuOpen ? " is-open" : ""}`}
                      onClick={() => setLoginMenuOpen((open) => !open)}
                      aria-haspopup="menu"
                      aria-expanded={loginMenuOpen}
                      aria-controls="lp-login-menu"
                    >
                      <span className="lp-nav-btn-label lp-nav-btn-label--login">Log In</span>
                      <span className="lp-login-caret" aria-hidden>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="#0A2885" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                    </button>
                    {loginMenuOpen ? (
                      <div className="lp-login-dropdown" id="lp-login-menu" role="menu" aria-label="Choose login destination">
                        <button
                          type="button"
                          className="lp-login-option"
                          role="menuitem"
                          onClick={handleLogin1}
                        >
                          <span className="lp-login-option-title">V1</span>
                          <span className="lp-login-option-hint">{loginHint(config.loginUrl)}</span>
                        </button>
                        <button
                          type="button"
                          className="lp-login-option"
                          role="menuitem"
                          onClick={handleLogin2}
                        >
                          <span className="lp-login-option-title">V2</span>
                          <span className="lp-login-option-hint">{loginHint(config.loginUrl2)}</span>
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <button type="button" className="lp-nav-btn lp-nav-btn--demo" onClick={handleBookDemo}>
                    <span className="lp-nav-btn-label lp-nav-btn-label--demo">Request Demo</span>
                    <span className="lp-nav-btn-icon" aria-hidden><ArrowRightSVG width={16} height={16} stroke="white" /></span>
                  </button>

                  {/* ≤640px only (CSS-gated): nav, login, and demo live behind this toggle. */}
                  <div className="lp-mobile-nav" ref={mobileNavRef}>
                    <button
                      type="button"
                      className={`lp-nav-toggle${mobileNavOpen ? " is-open" : ""}`}
                      onClick={() => setMobileNavOpen((open) => !open)}
                      aria-haspopup="menu"
                      aria-expanded={mobileNavOpen}
                      aria-controls="lp-mobile-nav-menu"
                      aria-label={mobileNavOpen ? "Close menu" : "Open menu"}
                    >
                      <span className="lp-nav-toggle-bars" aria-hidden>
                        <span />
                        <span />
                        <span />
                      </span>
                    </button>
                    {mobileNavOpen ? (
                      <div
                        className="lp-mobile-nav-menu"
                        id="lp-mobile-nav-menu"
                        role="menu"
                        aria-label="Primary navigation"
                      >
                        {navItems.map((item) => (
                          <button
                            key={item.id || item.label}
                            type="button"
                            className="lp-mobile-nav-link"
                            role="menuitem"
                            onClick={() => {
                              setMobileNavOpen(false);
                              goToNavItem(item);
                            }}
                          >
                            {item.label}
                          </button>
                        ))}
                        <div className="lp-mobile-nav-divider" role="separator" />
                        <button
                          type="button"
                          className="lp-mobile-nav-link"
                          role="menuitem"
                          onClick={() => {
                            setMobileNavOpen(false);
                            handleLogin1();
                          }}
                        >
                          <span>Log In — V1</span>
                          <span className="lp-mobile-nav-hint">{loginHint(config.loginUrl)}</span>
                        </button>
                        <button
                          type="button"
                          className="lp-mobile-nav-link"
                          role="menuitem"
                          onClick={() => {
                            setMobileNavOpen(false);
                            handleLogin2();
                          }}
                        >
                          <span>Log In — V2</span>
                          <span className="lp-mobile-nav-hint">{loginHint(config.loginUrl2)}</span>
                        </button>
                        <button
                          type="button"
                          className="lp-mobile-nav-link lp-mobile-nav-link--demo"
                          role="menuitem"
                          onClick={() => {
                            setMobileNavOpen(false);
                            handleBookDemo();
                          }}
                        >
                          Request Demo
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </header>

            <div className="lp-hero-columns">
              <div className="lp-hero-left">
                <div className="lp-hero-title-wrap">
                  <h1 className="lp-hero-h1">
                    <span className="lp-copy-desktop">
                      <span className="lp-hero-h1-line">Built for DPDPA.</span>
                      <span className="lp-hero-h1-line">Ready for any</span>
                      <span className="lp-hero-h1-line">organisation.</span>
                    </span>
                    <span className="lp-copy-mobile">Built for DPDPA. Ready for any organisation.</span>
                  </h1>
                </div>
                <div className="lp-hero-sub-wrap">
                  <p className="lp-hero-lead">
                    From a single module to the full compliance suite — consent,
                    cookie consent, rights, grievances, records, and breach
                    management, all in one place. Whether you're getting
                    started or managing compliance at scale, it fits.
                  </p>
                </div>
                <div className="lp-hero-cta">
                  <button type="button" className="lp-hero-cta-btn" onClick={handleBookDemo}>
                    <span className="lp-hero-cta-label">Request Demo</span>
                    <span className="lp-hero-cta-icon" aria-hidden><ArrowRightSVG width={16} height={16} stroke="white" /></span>
                  </button>
                </div>
              </div>
              <div className="lp-hero-right">
                <img src={heroImage} alt="Consent management dashboard" className="lp-hero-image" width={592} height={568} draggable={false} />
              </div>
            </div>
          </section>
        </div>

        {/* ── Section 2: Trust & Recognition ── */}
        <div className="lp-scroll-section" ref={(el) => { sectionRefs.current[1] = el; }} aria-label="Trust and recognition">
          <section className="lp-social-proof" aria-label="Trust and recognition">
            <div className="lp-social-proof-inner">
              <div className="lp-meity-title-block">
                <h2 className="lp-meity-section-title">
                  Winners of MeitY Code for Consent Challenge
                </h2>
                <img
                  src={winnersOfMeityImg}
                  alt="Winners of MeitY Code for Consent Challenge"
                  className="lp-meity-winners-img"
                  draggable={false}
                />
              </div>
              <div className="lp-meity-layout">
                <div className="lp-meity-left">
                  <div className="lp-meity-left-content">
                    <div className="lp-meity-ribbon">
                      <img
                        src={meityRecognisedRibbon}
                        alt="MeitY recognised"
                        className="lp-meity-figma-ribbon"
                        width={219}
                        height={64}
                        draggable={false}
                      />
                    </div>
                    <h3 className="lp-proven-headline">
                      <ResponsiveCopy
                        lines={["Proven at scale, recognised at the", "highest level"]}
                      />
                    </h3>
                    <p className="lp-meity-desc">
                      Selected among the top 2 solutions in India at MeitY's DPDP
                      Code for Consent Challenge, competing against 65+ entries
                      from across the country.
                    </p>
                  </div>
                </div>
                <div className="lp-meity-right">
                  {MEITY_STATS.map((row) => {
                    const StatIco = row.Icon;
                    return (
                      <div key={row.value} className="lp-stat-row">
                        <div className="lp-stat-icon">
                          <span className={`lp-stat-icon-box${row.figmaLogo ? " lp-stat-icon-box--figma" : ""}`}>
                            {row.figmaLogo ? (
                              <StatIco className="lp-stat-figma-logo" />
                            ) : (
                              <Icon color="primary" ic={<StatIco />} kind="background" size="small" />
                            )}
                          </span>
                        </div>
                        <div className="lp-stat-copy">
                          <Text appearance="heading-xs" color="primary_grey_100" className="lp-stat-value">{row.value}</Text>
                          <Text appearance="body-s" color="primary_grey_80" className="lp-stat-desc">{row.label}</Text>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="lp-trusted-block">
                <Text appearance="body-s-bold" color="primary_grey_100" className="lp-trusted-eyebrow">TRUSTED BY BUSINESSES</Text>
                <div className="lp-trusted-logos-row" role="list" aria-label="Partner brands">
                  <div className="lp-trusted-logo-slot lp-trusted-logo-slot--facebook" role="listitem">
                    <span className="lp-trusted-fb-logo" aria-label="Facebook">
                      <TrustedFacebookIcon className="lp-trusted-fb-icon" />
                      <TrustedFacebookWordmark className="lp-trusted-fb-wordmark-svg" />
                    </span>
                  </div>
                  <div className="lp-trusted-logo-slot lp-trusted-logo-slot--jewels" role="listitem">
                    <TrustedRelianceJewelsLogo className="lp-trusted-jewels-logo" />
                  </div>
                  <div className="lp-trusted-logo-slot lp-trusted-logo-slot--medical" role="listitem">
                    <TrustedRelianceMedicalLogo className="lp-trusted-medical-logo" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* ── Section 3: Platform + How (one scroll block; continuous scroll between them) ── */}
        <div className="lp-scroll-section" ref={(el) => { sectionRefs.current[2] = el; }} aria-label="Platform features and how it works">
          <section className="lp-platform" id="lp-section-features" aria-label="Platform features">
            <div className="lp-platform-glow" aria-hidden />
            <div className="lp-platform-intro">
              <Text appearance="body-xs-bold" color="primary_grey_60" className="lp-platform-eyebrow">PLATFORM FEATURES &amp; MODULES</Text>
              <h2 className="lp-platform-headline">
                <span className="lp-copy-desktop">
                  <span className="lp-platform-headline-line lp-platform-headline-line--1">
                    Complete compliance suite covering
                  </span>
                  <span className="lp-platform-headline-line lp-platform-headline-line--2">every obligation</span>
                </span>
                <span className="lp-copy-mobile">
                  <span className="lp-platform-headline-line">Complete compliance suite</span>
                  <span className="lp-platform-headline-line">covering every obligation</span>
                </span>
              </h2>
              <p className="lp-platform-lead">
                Designed to work for teams of all sizes and connect with your existing systems and processes
              </p>
            </div>
            <div className="lp-platform-grid lp-platform-grid--five">
              {PLATFORM_FEATURES.map((card) => (
                <PlatformFeatureCard
                  key={card.title}
                  {...card}
                  onReadMoreClick={
                    card.id === "consent"
                      ? () => setReadMoreModal("consent")
                      : card.id === "cookie"
                        ? () => setReadMoreModal("cookie")
                        : card.id === "grievance"
                          ? () => setReadMoreModal("grievance")
                          : undefined
                  }
                />
              ))}
            </div>
          </section>

          {/* How it works — same vertical block as Platform */}
          <section className="lp-how" id="lp-section-how" aria-label="How it works">
            <Text appearance="body-xs-bold" color="primary_grey_60">HOW IT WORKS</Text>
            <div className="lp-how-title">
              <h2 className="lp-how-headline">Up and running in days, not months</h2>
            </div>
            <div className="lp-how-sub">
                <Text appearance="body-m" color="primary_grey_80">
                  Built on open standards and a modular API architecture, so your team can integrate, monitor, and report without rebuilding what you already have.
                </Text>
            </div>

            <div className="lp-how-cards">
              {HOW_STEPS.map((step) => (
                <article key={step.badge} className="lp-how-card">
                  <div className="lp-how-card-visual" aria-hidden>
                    <img
                      className="lp-how-card-img"
                      src={step.illustration}
                      alt=""
                      width={410}
                      height={280}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="lp-how-card-body">
                    <span className="lp-how-step-badge">{step.badge}</span>
                    <Text appearance="heading-xs" color="primary_grey_100" className="lp-how-card-title">
                      {step.title}
                    </Text>
                    <Text appearance="body-s" color="primary_grey_80" className="lp-how-card-desc">
                      {step.description}
                    </Text>
                    <a
                      className="lp-how-read-more"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setReadMoreModal(step.readMoreKey);
                      }}
                    >
                      Read more
                      <ArrowRightSVG width={20} height={20} stroke="#0A2885" />
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </section>
        </div>

        {/* ── Section 4: Developer Hub + FAQ + CTA ── */}
        <div className="lp-scroll-section" ref={(el) => { sectionRefs.current[3] = el; }} aria-label="Developer hub, FAQ and contact">
          <section className="lp-dev-hub" id="lp-section-developers" aria-labelledby="lp-dev-hub-heading">
            <div className="lp-dev-hub-inner">
              {/* Figma: 1280 column, 16px gap stack, 40px padding below CTA before graphic */}
              <div className="lp-dev-hub-intro">
                <div className="lp-dev-hub-head">
                  <Text appearance="body-xs-bold" color="primary_grey_60" className="lp-dev-hub-eyebrow">
                    FOR DEVELOPERS
                  </Text>
                </div>
                <div className="lp-dev-hub-title">
                  <h2 id="lp-dev-hub-heading" className="lp-dev-hub-heading">
                    Detailed API references, SDK documentation, authentication{"\u00A0"}flows, and integration guides are in the Developer Hub
                  </h2>
                </div>
                <div className="lp-dev-hub-cta">
                  <Button
                    kind="secondary"
                    label="Go to Developer Documentation →"
                    size="large"
                    onClick={handleDevDocs}
                  />
                </div>
              </div>
              <div className="lp-dev-graphic">
                <img
                  className="lp-dev-hub-illustration"
                  src={forDevelopersIllustration}
                  alt=""
                  width={1152}
                  height={330}
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </section>

          <section className="lp-faq-section" id="lp-section-faq">
            <div className="lp-faq-inner">
              <div className="lp-faq-head">
                <h2 className="lp-faq-headline">Frequently asked questions</h2>
              </div>
              <div className="lp-faq-list lp-faq-list--minimal">
                {FAQ_LIST.map((item, index) => (
                  <div key={item.question} className="lp-faq-item lp-faq-item--minimal">
                    <div
                      className="lp-faq-q"
                      role="button"
                      tabIndex={0}
                      onClick={() => setFaqOpen(faqOpen === index ? -1 : index)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setFaqOpen(faqOpen === index ? -1 : index);
                        }
                      }}
                    >
                      <Text appearance="body-s-bold" color="primary_grey_100">{item.question}</Text>
                      <span className="lp-faq-plus" aria-hidden>
                        {faqOpen === index ? <FaqToggleMinus /> : <FaqTogglePlus />}
                      </span>
                    </div>
                    {faqOpen === index && (
                      <div className="lp-faq-a">
                        <Text appearance="body-s" color="primary_grey_80">{item.answer}</Text>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="lp-final-cta lp-final-cta--surface">
            <div className="lp-final-inner">
              <div className="lp-final-copy">
                <Text appearance="heading-l" color="primary_grey_100" className="lp-final-headline">
                  <ResponsiveCopy
                    lines={["Ready to simplify your", "compliance journey?"]}
                  />
                </Text>
                <div className="lp-final-sub">
                  <Text appearance="body-m" color="primary_grey_80" className="lp-final-sub-lead">
                    <ResponsiveCopy
                      lines={[
                        "Join leading enterprises that trust Jio Consent Management",
                        "to handle their data privacy effortlessly.",
                      ]}
                    />
                  </Text>
                </div>
              </div>
              <div className="lp-final-cta-btn">
                <Button
                  kind="primary"
                  label="Request Demo"
                  size="medium"
                  className="lp-final-demo-btn"
                  icon={arrowIcon(20)}
                  onClick={handleBookDemo}
                />
              </div>
              <div className="lp-final-trust-grid">
                {FINAL_TRUST_BADGES.map((b) => {
                  const Ico = b.IconComponent;
                  return (
                    <div key={b.label} className="lp-final-trust-item">
                      <span className="lp-final-trust-icon">
                        <Ico />
                      </span>
                      <Text appearance="body-s-bold" color="primary_grey_100">{b.label}</Text>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>

          <footer className="lp-footer" role="contentinfo">
            <div className="lp-footer-row">
              <div className="lp-footer-brand">
                <span className="lp-footer-logo" aria-hidden>
                  <JioLogoSVG width={32} height={32} />
                </span>
                <span className="lp-footer-copyright">
                  Copyright © 2026 Reliance Jio Infocomm Ltd. All rights reserved.
                </span>
              </div>
              <nav className="lp-footer-links" aria-label="Legal">
                <a
                  className="lp-footer-link"
                  href="/pdf/privacy-policy"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/pdf/privacy-policy");
                  }}
                >
                  Policies
                </a>
                <a
                  className="lp-footer-link"
                  href="/pdf/terms-of-use"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/pdf/terms-of-use");
                  }}
                >
                  Terms &amp; Conditions
                </a>
              </nav>
            </div>
          </footer>
        </div>

      </div>

      {readMoreModal && readMoreBundle
        ? createPortal(
          <div
            className="lp-consent-modal-backdrop"
            role="presentation"
            onClick={() => setReadMoreModal(null)}
          >
            <div
              className="lp-consent-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby={readMoreBundle.titleId}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="lp-consent-modal-close"
                aria-label="Close"
                onClick={() => setReadMoreModal(null)}
              >
                ×
              </button>
              <div className="lp-consent-modal-grid">
                <div className="lp-consent-modal-copy">
                  <span className="lp-consent-modal-eyebrow">{readMoreBundle.copy.eyebrow}</span>
                  <h2 id={readMoreBundle.titleId} className="lp-consent-modal-title">
                    {readMoreBundle.copy.title}
                  </h2>
                  {Array.isArray(readMoreBundle.copy.leadParagraphs) && readMoreBundle.copy.leadParagraphs.length > 0 ? (
                    readMoreBundle.copy.leadParagraphs.map((para, idx) => (
                      <p key={idx} className="lp-consent-modal-lead">
                        {para}
                      </p>
                    ))
                  ) : (
                    <p className="lp-consent-modal-lead">{readMoreBundle.copy.lead}</p>
                  )}
                  <ul className="lp-consent-modal-list">
                    {readMoreBundle.copy.bullets.map((item, idx) => {
                      const key = typeof item === "string" ? item : `lp-modal-bullet-${idx}`;
                      const line =
                        typeof item === "string" ? (
                          item
                        ) : (
                          <>
                            <strong>{item.head}</strong>
                            {item.tail}
                          </>
                        );
                      return (
                        <li key={key} className="lp-consent-modal-li">
                          <span className="lp-consent-modal-check" aria-hidden>✓</span>
                          <span className="lp-consent-modal-li-text">{line}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="lp-consent-modal-visual" aria-hidden>
                  <img
                    className={
                      readMoreModal === "cookie"
                        ? "lp-consent-modal-visual-img lp-consent-modal-visual-img--cookie"
                        : "lp-consent-modal-visual-img"
                    }
                    src={readMoreBundle.illustration}
                    alt=""
                    width={readMoreModal === "cookie" ? 360 : 480}
                    height={readMoreModal === "cookie" ? 232 : 520}
                    decoding="async"
                  />
                </div>
              </div>
            </div>
          </div>,
          document.body
        )
        : null}

      {demoModal
        ? createPortal(
          <div
            className="lp-demo-modal-backdrop"
            role="presentation"
            onClick={closeDemoModal}
          >
            <div
              className="lp-demo-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="lp-demo-modal-title"
              onClick={(e) => e.stopPropagation()}
            >
              <button type="button" className="lp-demo-modal-close" aria-label="Close" onClick={closeDemoModal}>
                ×
              </button>
              <div className="lp-demo-modal-head">
                <h2 id="lp-demo-modal-title" className="lp-demo-modal-title">
                  Request a demo
                </h2>
              </div>
              {demoModal === "form" ? (
                <form className="lp-demo-modal-body" onSubmit={handleDemoFormSubmit} noValidate>
                  <div className="lp-demo-modal-field">
                    <label className="lp-demo-modal-label" htmlFor="lp-demo-fullname">
                      Full name <span className="lp-demo-modal-star" aria-hidden>*</span>
                    </label>
                    <input
                      id="lp-demo-fullname"
                      className="lp-demo-modal-input"
                      name="fullName"
                      autoComplete="name"
                      placeholder="e.g. Priya Sharma"
                      value={demoForm.fullName}
                      onChange={(e) => setDemoForm((p) => ({ ...p, fullName: e.target.value }))}
                    />
                  </div>
                  <div className="lp-demo-modal-field">
                    <label className="lp-demo-modal-label" htmlFor="lp-demo-email">
                      Work email <span className="lp-demo-modal-star" aria-hidden>*</span>
                    </label>
                    <input
                      id="lp-demo-email"
                      className="lp-demo-modal-input"
                      name="email"
                      type="email"
                      autoComplete="email"
                      placeholder="you@company.com"
                      value={demoForm.workEmail}
                      onChange={(e) => setDemoForm((p) => ({ ...p, workEmail: e.target.value }))}
                    />
                  </div>
                  <div className="lp-demo-modal-field">
                    <label className="lp-demo-modal-label" htmlFor="lp-demo-company">
                      Company <span className="lp-demo-modal-star" aria-hidden>*</span>
                    </label>
                    <input
                      id="lp-demo-company"
                      className="lp-demo-modal-input"
                      name="organization"
                      autoComplete="organization"
                      placeholder="Organisation name"
                      value={demoForm.company}
                      onChange={(e) => setDemoForm((p) => ({ ...p, company: e.target.value }))}
                    />
                  </div>
                  <div className="lp-demo-modal-row2">
                    <div className="lp-demo-modal-field">
                      <label className="lp-demo-modal-label" htmlFor="lp-demo-phone">
                        Phone
                      </label>
                      <input
                        id="lp-demo-phone"
                        className="lp-demo-modal-input"
                        name="tel"
                        type="tel"
                        autoComplete="tel"
                        placeholder="Optional"
                        value={demoForm.phone}
                        onChange={(e) => setDemoForm((p) => ({ ...p, phone: e.target.value }))}
                      />
                    </div>
                    <div className="lp-demo-modal-field">
                      <label className="lp-demo-modal-label" htmlFor="lp-demo-job">
                        Job title
                      </label>
                      <input
                        id="lp-demo-job"
                        className="lp-demo-modal-input"
                        name="jobTitle"
                        autoComplete="organization-title"
                        placeholder="Optional"
                        value={demoForm.jobTitle}
                        onChange={(e) => setDemoForm((p) => ({ ...p, jobTitle: e.target.value }))}
                      />
                    </div>
                  </div>
                  <div className="lp-demo-modal-field">
                    <label className="lp-demo-modal-label" htmlFor="lp-demo-message">
                      What would you like to see?
                    </label>
                    <textarea
                      id="lp-demo-message"
                      className="lp-demo-modal-textarea"
                      name="message"
                      rows={4}
                      placeholder="Modules of interest, timeline, or questions"
                      value={demoForm.message}
                      onChange={(e) => setDemoForm((p) => ({ ...p, message: e.target.value }))}
                    />
                  </div>
                  <div className="lp-demo-modal-consent">
                    <input
                      id="lp-demo-consent"
                      className="lp-demo-modal-checkbox"
                      type="checkbox"
                      checked={demoForm.consent}
                      onChange={(e) => setDemoForm((p) => ({ ...p, consent: e.target.checked }))}
                    />
                    <label htmlFor="lp-demo-consent" className="lp-demo-modal-consent-label">
                      I agree to be contacted about Jio Consent Management and understand I can withdraw this request at
                      any time.
                    </label>
                  </div>
                  <div className="lp-demo-modal-actions">
                    <button type="button" className="lp-demo-modal-btn lp-demo-modal-btn--cancel" onClick={closeDemoModal}>
                      Cancel
                    </button>
                    <button type="submit" className="lp-demo-modal-btn lp-demo-modal-btn--submit">
                      Submit request
                    </button>
                  </div>
                </form>
              ) : (
                <div className="lp-demo-modal-success">
                  <h3 className="lp-demo-modal-thanks">Thank you</h3>
                  <p className="lp-demo-modal-success-msg">
                    We&apos;ve received your request. A member of our team will contact you shortly.
                  </p>
                  <button type="button" className="lp-demo-modal-btn lp-demo-modal-btn--close-pill" onClick={closeDemoModal}>
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>,
          document.body
        )
        : null}
    </TokenProvider>
  );
};

export default LandingPage;
